import CKEditorField from './CKEditorField';

export default CKEditorField;
